import { ComponentInfoActions } from './component-info/component-info.actions';
import { ProviderActions } from './provider/provider.actions';
import { LoggedInUserActions } from './logged-in-user/logged-in-user.actions';

export class SharedActions {
  static readonly ComponentInfo = ComponentInfoActions;
  static readonly Provider = ProviderActions;
  static readonly LoggedInUser = LoggedInUserActions;
}
